import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportListingComponent } from './report-listing/report-listing.component';

@NgModule({
  imports: [CommonModule],
  exports: [ReportListingComponent],
  declarations: [ReportListingComponent],
})
export class ReportsModule {}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/reports/reports.module.ts